import { render, staticRenderFns } from "./storeShortDataFromJson.vue?vue&type=template&id=072a20b0&"
import script from "./storeShortDataFromJson.vue?vue&type=script&lang=js&"
export * from "./storeShortDataFromJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports